"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onQualitiesLoaded;
var _JwQualityHelper = require("../JwQualityHelper");
function onQualitiesLoaded(event) {
  this._qualities = (0, _JwQualityHelper.normaliseQualities)(this.src, this.rawPlayer.getQualityLevels());
  this.rawPlayer.setCurrentQuality(0);
  this._activeQuality = event.levels[event.currentQuality];
}